<template>
  <b-row>
    <b-col cols="12" class="mt-2">
      <b-alert :show="feedback.show"
               dismissible
               :variant="feedback.variant"
               @dismissed="dismissFeedback"
               @dismiss-count-down="countdownFeedback">
        {{feedback.text}}
        <ul v-if="errors" class="mt-3">
          <li v-for="error in errors">{{error.toString()}}</li>
        </ul>
      </b-alert>
      <table class="table">
        <thead>
        <tr>
          <th>Inhoud</th>
          <th>Volgorde</th>
          <th>Acties</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(block, index) in page.blocks">
<!--          <td>{{ blockHeader(block) }}</td>-->


          <td v-if="block.type == 'image'">
            <img v-bind:src="block.featured_media.responsive.md">
          </td>
          <td v-if="block.type == 'text'">
          {{ block.text }}
          </td>

          <td>
            <i class="icon-arrow-down-circle icons text-primary h5 mr-1" @click="moveOrderDown(block.id)" v-if="index != Object.keys(page.blocks).length - 1"></i>
            <i class="icon-arrow-up-circle icons text-primary h5" @click="moveOrderUp(block.id)" v-if="index != 0"></i>
          </td>
          <td>
            <b-button variant="primary" size="sm" class="mr-1" @click="editBlock(block)">Bewerk</b-button>
            <b-button variant="danger" size="sm" @click="deleteBlock(block)">Verwijder</b-button>
          </td>
        </tr>
        </tbody>
      </table>
    </b-col>

    <b-col cols="12" class="mb-3">
      <b-button variant="primary" @click="setActivePlaceholder('image')" :disabled="activePlaceholder !== null" class="mr-2">
        Afbeelding toevoegen
      </b-button>
      <b-button variant="primary" @click="setActivePlaceholder('wysiwyg')" :disabled="activePlaceholder !== null" class="mr-2">
        Tekst toevoegen
      </b-button>
    </b-col>


    <b-col cols="12" v-if="activePlaceholder === 'image'">
      <hr>
      <b-card :header="placeholders.image.id !== null ? 'Afbeelding bewerken' : 'Afbeelding toevoegen'">
        <b-form @submit.prevent="saveImage">
          <b-row>
            <b-col>
              <image-upload
                label="Afbeelding"
                :editable="true"
                v-model="placeholders.image.media_object"
                :image="placeholders.image.featured_media"
                @clear="placeholders.image.featured_media = ''">
              </image-upload>
            </b-col>
            <b-col>
              <b-form-group label="Onderschrift">
                <b-form-input type="text" v-model="placeholders.image.caption"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button type="submit" variant="danger" class="mr-2" @click="setActivePlaceholder(null)">Annuleren</b-button>
          <b-button type="submit" variant="success">
            <span v-if="placeholders.image.id !== null">Opslaan</span>
            <span v-else>Toevoegen</span>
          </b-button>
        </b-form>
      </b-card>
    </b-col>

    <b-col cols="12" v-if="activePlaceholder === 'wysiwyg'">
      <hr>
      <b-card :header="placeholders.wysiwyg.id !== null ? 'Tekst bewerken' : 'Tekst toevoegen'">
        <b-form @submit.prevent="saveWysiwyg">
          <b-row>
            <b-col>
              <b-form-group label="Content">
                <ckeditor v-model="placeholders.wysiwyg.text" :editor="editor" :config="editorConfig"></ckeditor>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button type="submit" variant="danger" class="mr-2" @click="setActivePlaceholder(null)">Annuleren</b-button>
          <b-button type="submit" variant="success">
            <span v-if="placeholders.wysiwyg.id !== null">Bewerken</span>
            <span v-else>Toevoegen</span>
          </b-button>
        </b-form>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import ImageUpload from "@/components/FormGroups/ImageUpload";
  import {addData, deleteItem, getData, updateData} from "@/api";

  export default {
    name: 'blocks',

    props: {
      page: {
        type: Object,
        required: true
      }
    },

    components: {
      ImageUpload,
      ClassicEditor
    },

    data() {
      return {
        blocks: {},

        errors: null,

        activePlaceholder: null,

        placeholders: {},

        feedback: {
          show: 0,
          text: '',
          variant: null,
          seconds: 10
        },

        editor: ClassicEditor,

        editorConfig: {
          toolbar:  ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'insertTable'],
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells'
            ]
          },
          heading: {
            options: [
              { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
              { model: 'heading2', view: 'h2', title: 'Heading 2'},
              { model: 'heading3', view: 'h3', title: 'Heading 3'},
              { model: 'heading4', view: 'h4', title: 'Heading 4'},
            ]
          }
        }
      }
    },

    methods: {
      async refresh() {
        this.$emit('refresh');
      },

      async moveOrderUp(id) {
        await updateData(`news-articles/${this.page.id}/text-blocks/${id}/up`).then(response => response.data);
        await this.refresh();
      },
      async moveOrderDown(id) {
        await updateData(`news-articles/${this.page.id}/text-blocks/${id}/down`).then(response => response.data);
        await this.refresh();
      },

      clearPlaceholders() {
        this.placeholders = {
          image: {
            id: null,
            featured_media: '',
            media_object: '',
            caption: ''
          },
          wysiwyg: {
            id: null,
            text: null
          },
        }
      },

      setActivePlaceholder(placeholder) {
        if (placeholder === null) {
          this.clearPlaceholders();
        }

        this.activePlaceholder = placeholder;
      },


      saveImage() {
        if (this.placeholders.image.id !== null) {
          updateData(
            `news-articles/${this.page.id}/image-blocks/${this.placeholders.image.id}`,
            this.formDataFromObject({
              featured_media: this.placeholders.image.featured_media,
              media_object: this.placeholders.image.media_object,
              caption: this.placeholders.image.caption
            })
          ).then(response => {
            this.handleSaveOrUpdateResponse(response, 'De wijzigingen aan de afbeelding zijn opgeslagen.');
          })
        } else {
          addData(
            `news-articles/${this.page.id}/image-blocks`,
            this.formDataFromObject({
              featured_media: this.placeholders.image.featured_media,
              media_object: this.placeholders.image.media_object,
              caption: this.placeholders.image.caption
            })
          ).then(response => {
            this.handleSaveOrUpdateResponse(response, 'De afbeelding is opgeslagen.');
          })
        }
      },

      saveWysiwyg() {
        if (this.placeholders.wysiwyg.id !== null) {
          updateData(
            `news-articles/${this.page.id}/text-blocks/${this.placeholders.wysiwyg.id}`,
            this.formDataFromObject({
              text: this.placeholders.wysiwyg.text
            })
          ).then(response => {
            this.handleSaveOrUpdateResponse(response, 'De wijzigingen aan de tekst zijn opgeslagen.');
          })
        } else {
          addData(
            `news-articles/${this.page.id}/text-blocks`,
            this.formDataFromObject({
              text: this.placeholders.wysiwyg.text
            })
          ).then(response => {
            this.handleSaveOrUpdateResponse(response, 'De tekst is opgeslagen.');
          })
        }
      },


      handleSaveOrUpdateResponse(response, successMessage) {
        if (response.status === 200 || response.status === 201) {
          this.showFeedback('success', successMessage);
          this.setActivePlaceholder(null);
          this.refresh();
        } else {
          this.errors = response.data.errors;
          this.showFeedback('danger', 'Er is iets mis...');
        }
      },

      editBlock(block) {
        switch (block.type) {
          case 'image':
            this.placeholders.image = {
              id: block.id,
              featured_media: block.featured_media,
              media_object: '',
              caption: block.caption

            }

            this.setActivePlaceholder('image');

            break;
          case 'text':
            this.placeholders.wysiwyg = {
              id: block.id,
              text: block.text,
            }

            this.setActivePlaceholder('wysiwyg');

            break;
        }
      },

      async deleteBlock(block) {
        // TODO: should we add a confirmation dialog here?
        await deleteItem(`/academy/content/${block.id}`);
        await this.refresh();
      },

      showFeedback(variant, message) {
        if (variant === 'success') {
          this.errors = null;
        }

        this.feedback.show = this.feedback.seconds;
        this.feedback.text = message;
        this.feedback.variant = variant;
      },

      dismissFeedback() {
        this.errors = null;
        this.feedback.show = 0;
        this.feedback.text = '';
        this.feedback.variant = null;
      },

      countdownFeedback(seconds) {
        this.feedback.show = seconds;
      },

      formDataFromObject(object) {
        let formData = new FormData();

        Object.keys(object).forEach(key => {
          formData.append(key, object[key]);
        });

        return formData;
      },

      blockHeader(block){
          if (block.type === 'text') return 'Tekst';

          return 'Afbeelding'
      }
    },

    beforeMount() {
      this.clearPlaceholders();
    },
  }
</script>

<style scoped>
  .icon-arrow-down-circle,
  .icon-arrow-up-circle {
    transition: color linear 150ms;
  }

  .icon-arrow-down-circle:hover,
  .icon-arrow-up-circle:hover
  {
    cursor: pointer;
    color: #0c6c8e !important;
  }
</style>
